import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import BuyButton from "@/components/BuyButton";
import { captureRefFromUrl } from "@/lib/referral";

const SALES_CSS = `
  .sp{
    --paper:#F5F6F3;--ink:#0F1317;--slate:#59636E;--line:#D9DDD6;
    --cobalt:#2038E6;--cobalt-dk:#1526B8;--signal:#FFDF57;--card:#FFFFFF;
    background:var(--paper);color:var(--ink);font-family:'Inter',sans-serif;font-size:17px;line-height:1.6;-webkit-font-smoothing:antialiased;
  }
  .sp *{margin:0;padding:0;box-sizing:border-box}
  .sp ::selection{background:var(--signal)}
  .sp .wrap{max-width:960px;margin:0 auto;padding:0 24px}
  .sp .narrow{max-width:760px;margin:0 auto;padding:0 24px}
  .sp .eyebrow{font-family:'IBM Plex Mono',monospace;font-size:12px;letter-spacing:.14em;text-transform:uppercase;color:var(--cobalt);font-weight:600;display:block;margin-bottom:18px}
  .sp h1,.sp h2,.sp h3{font-family:'Archivo',sans-serif;font-stretch:87%;line-height:1.02;letter-spacing:-.01em}
  .sp h1{font-weight:900;font-size:clamp(40px,7vw,72px);text-transform:uppercase}
  .sp h2{font-weight:850;font-size:clamp(30px,4.6vw,46px);text-transform:uppercase}
  .sp h3{font-weight:750;font-size:21px;line-height:1.25}
  .sp .hl{background:linear-gradient(transparent 62%, var(--signal) 62%)}
  .sp .accent{color:var(--cobalt)}
  .sp p.lead{font-size:19px;color:var(--slate)}
  .sp section{padding:88px 0;border-top:1px solid var(--line)}
  .sp section:first-of-type{border-top:none}
  .sp .proofbar{background:var(--ink);color:#E9ECE7;font-family:'IBM Plex Mono',monospace;font-size:12px;letter-spacing:.1em;text-transform:uppercase;text-align:center;padding:10px 16px}
  .sp .proofbar b{color:var(--signal);font-weight:600}
  .sp .hero{text-align:center;padding:76px 0 72px}
  .sp .hero p.sub{font-size:20px;color:var(--slate);max-width:640px;margin:26px auto 0}
  .sp .hero .killers{display:flex;gap:10px;justify-content:center;flex-wrap:wrap;margin-top:22px}
  .sp .pill{font-family:'IBM Plex Mono',monospace;font-size:12px;letter-spacing:.06em;border:1px solid var(--line);background:var(--card);padding:7px 14px;border-radius:100px;color:var(--ink)}
  .sp .pill::before{content:"\\2715 ";color:var(--cobalt);font-weight:600}
  .sp .cta{margin:44px auto 0;max-width:520px;background:var(--card);border:1px solid var(--line);border-radius:14px;padding:30px 28px;text-align:center;box-shadow:0 1px 0 var(--line)}
  .sp .price{font-family:'IBM Plex Mono',monospace;font-size:15px;color:var(--slate);margin-bottom:14px}
  .sp .price s{opacity:.6;margin-right:10px}
  .sp .price b{color:var(--ink);font-size:26px;font-weight:600}
  .sp .btn{display:block;width:100%;background:var(--cobalt);color:#fff;font-family:'Archivo',sans-serif;font-weight:800;font-size:18px;text-transform:uppercase;letter-spacing:.03em;padding:19px 24px;border-radius:10px;text-decoration:none;transition:background .15s, transform .15s;border:none;cursor:pointer}
  .sp .btn:hover{background:var(--cobalt-dk);transform:translateY(-1px)}
  .sp .risk{font-size:13px;color:var(--slate);margin-top:14px}
  .sp .ph{position:relative;border:1.5px dashed #C9A227;background:#FFF9E3;border-radius:12px;padding:22px}
  .sp .ph::before{content:"PLACEHOLDER \\00B7 REPLACE WITH REAL PROOF";position:absolute;top:-9px;left:14px;background:#FFF9E3;font-family:'IBM Plex Mono',monospace;font-size:10px;letter-spacing:.12em;color:#8A6D00;padding:0 6px}
  .sp .steps{display:grid;grid-template-columns:repeat(4,1fr);gap:16px;margin-top:44px}
  .sp .step{background:var(--card);border:1px solid var(--line);border-radius:12px;padding:24px 20px}
  .sp .step .n{font-family:'IBM Plex Mono',monospace;font-size:12px;color:var(--cobalt);font-weight:600;letter-spacing:.1em;display:block;margin-bottom:12px}
  .sp .step h3{font-size:17px;margin-bottom:8px}
  .sp .step p{font-size:14px;color:var(--slate);line-height:1.5}
  .sp .ledger-sec{background:var(--ink);color:#E9ECE7;border-top:none}
  .sp .ledger-sec .eyebrow{color:var(--signal)}
  .sp .ledger-sec h2{color:#fff}
  .sp .ledger{display:grid;grid-template-columns:1fr auto 1fr;align-items:stretch;gap:0;margin-top:52px;border:1px solid #2A313A;border-radius:16px;overflow:hidden}
  .sp .ledger .side{padding:40px 34px}
  .sp .ledger .side.them{background:#161B21}
  .sp .ledger .side.you{background:#10151B}
  .sp .ledger .tag{font-family:'IBM Plex Mono',monospace;font-size:11px;letter-spacing:.14em;text-transform:uppercase;display:inline-block;padding:5px 12px;border-radius:100px;margin-bottom:20px}
  .sp .them .tag{background:#2A313A;color:#9AA4AE}
  .sp .you .tag{background:var(--signal);color:var(--ink);font-weight:600}
  .sp .ledger .offer-name{font-family:'Archivo',sans-serif;font-weight:800;font-size:22px;line-height:1.2;color:#fff;margin-bottom:10px}
  .sp .ledger .offer-price{font-family:'IBM Plex Mono',monospace;font-size:34px;font-weight:600}
  .sp .them .offer-price{color:#9AA4AE}
  .sp .you .offer-price{color:var(--signal)}
  .sp .ledger .desc{font-size:14px;color:#9AA4AE;margin-top:14px;line-height:1.55}
  .sp .mult{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:20px 26px;background:var(--cobalt)}
  .sp .mult .x{font-family:'Archivo',sans-serif;font-weight:900;font-size:clamp(48px,7vw,84px);color:#fff;line-height:1}
  .sp .mult .cap{font-family:'IBM Plex Mono',monospace;font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:#C6CDFF;margin-top:8px;text-align:center}
  .sp .ledger-note{font-family:'IBM Plex Mono',monospace;font-size:13px;color:#9AA4AE;text-align:center;margin-top:22px}
  .sp .duo{display:grid;grid-template-columns:1fr 1fr;gap:20px;margin-top:44px}
  .sp .duo .col{background:var(--card);border:1px solid var(--line);border-radius:14px;padding:32px 28px}
  .sp .duo .col.bad{border-top:4px solid #C64B3C}
  .sp .duo .col.good{border-top:4px solid var(--cobalt)}
  .sp .duo h3{margin-bottom:18px}
  .sp .duo ul{list-style:none}
  .sp .duo li{padding:10px 0;border-top:1px solid var(--line);font-size:15px;color:var(--slate)}
  .sp .duo li:first-of-type{border-top:none}
  .sp .duo .bad li::before{content:"\\2715 ";color:#C64B3C;font-weight:700}
  .sp .duo .good li::before{content:"\\2192 ";color:var(--cobalt);font-weight:700}
  .sp .plan{margin-top:44px;counter-reset:plan}
  .sp .plan .row{display:grid;grid-template-columns:72px 1fr;gap:22px;padding:26px 0;border-top:1px solid var(--line);align-items:start}
  .sp .plan .row:first-child{border-top:none}
  .sp .plan .num{font-family:'Archivo',sans-serif;font-weight:900;font-size:40px;color:var(--cobalt);line-height:1}
  .sp .plan h3{margin-bottom:6px}
  .sp .plan p{color:var(--slate);font-size:15px}
  .sp .plan .when{font-family:'IBM Plex Mono',monospace;font-size:11px;letter-spacing:.1em;text-transform:uppercase;color:var(--cobalt);display:block;margin-bottom:6px}
  .sp .bio{display:grid;grid-template-columns:1fr 1.4fr;gap:44px;margin-top:44px;align-items:start}
  .sp .bio .photo{aspect-ratio:4/5;background:repeating-linear-gradient(45deg,#E8EAE5,#E8EAE5 12px,#F0F2ED 12px,#F0F2ED 24px);border-radius:14px;border:1px solid var(--line);display:flex;align-items:center;justify-content:center;font-family:'IBM Plex Mono',monospace;font-size:12px;color:var(--slate);overflow:hidden}
  .sp .bio .photo img{width:100%;height:100%;object-fit:cover;object-position:center top;display:block}
  .sp .cred{list-style:none;margin:20px 0}
  .sp .cred li{font-size:15px;padding:9px 0;border-top:1px solid var(--line)}
  .sp .cred li:first-child{border-top:none}
  .sp .cred li::before{content:"\\25A0 ";color:var(--cobalt);font-size:10px;vertical-align:2px}
  .sp .belief{font-family:'Archivo',sans-serif;font-weight:800;font-size:24px;line-height:1.25;margin-top:26px}
  .sp .tgrid{display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-top:44px}
  .sp .tcard p{font-size:15px;line-height:1.55}
  .sp .tcard .who{font-family:'IBM Plex Mono',monospace;font-size:12px;color:var(--slate);margin-top:12px}
  .sp .ftc{font-size:12px;color:var(--slate);margin-top:24px;max-width:640px}
  .sp .qual{display:grid;grid-template-columns:1fr 1fr;gap:20px;margin-top:44px}
  .sp .qual .col{border-radius:14px;padding:32px 28px}
  .sp .qual .yes{background:var(--ink);color:#E9ECE7}
  .sp .qual .yes h3{color:#fff}
  .sp .qual .no{background:var(--card);border:1px solid var(--line)}
  .sp .qual ul{list-style:none;margin-top:16px}
  .sp .qual li{padding:9px 0;font-size:15px}
  .sp .qual .yes li{border-top:1px solid #2A313A;color:#C4CBD2}
  .sp .qual .no li{border-top:1px solid var(--line);color:var(--slate)}
  .sp .qual li:first-of-type{border-top:none}
  .sp .qual .yes li::before{content:"\\2713 ";color:var(--signal);font-weight:700}
  .sp .qual .no li::before{content:"\\2715 ";color:#C64B3C;font-weight:700}
  .sp .stack{margin-top:44px;background:var(--card);border:1px solid var(--line);border-radius:16px;overflow:hidden}
  .sp .stack .item{display:grid;grid-template-columns:1fr auto;gap:18px;padding:22px 28px;border-top:1px solid var(--line);align-items:center}
  .sp .stack .item:first-child{border-top:none}
  .sp .stack h3{font-size:17px;margin-bottom:4px}
  .sp .stack p{font-size:14px;color:var(--slate)}
  .sp .stack .val{font-family:'IBM Plex Mono',monospace;font-size:14px;color:var(--slate);white-space:nowrap}
  .sp .stack .item.bonus{background:#FFFBEA}
  .sp .stack .item.bonus .val{color:#8A6D00;font-weight:600}
  .sp .bonus-tag{font-family:'IBM Plex Mono',monospace;font-size:10px;letter-spacing:.12em;background:var(--signal);padding:3px 8px;border-radius:4px;margin-right:8px;font-weight:600}
  .sp .total{display:flex;justify-content:space-between;align-items:baseline;padding:26px 28px;background:var(--ink);color:#fff}
  .sp .total .label{font-family:'IBM Plex Mono',monospace;font-size:13px;letter-spacing:.1em;text-transform:uppercase;color:#9AA4AE}
  .sp .total .figs{font-family:'IBM Plex Mono',monospace;font-size:20px}
  .sp .total .figs s{color:#59636E;margin-right:14px}
  .sp .total .figs b{color:var(--signal);font-size:28px;font-weight:600}
  .sp .refer{background:var(--cobalt);color:#fff;border-radius:16px;padding:44px 40px;margin-top:0;text-align:center}
  .sp .refer h2{color:#fff;font-size:clamp(24px,3.6vw,34px)}
  .sp .refer p{color:#C6CDFF;margin-top:14px;max-width:560px;margin-left:auto;margin-right:auto}
  .sp .guarantee{display:grid;grid-template-columns:auto 1fr;gap:30px;align-items:start;background:var(--card);border:1px solid var(--line);border-radius:16px;padding:38px 34px;margin-top:44px}
  .sp .seal{width:110px;height:110px;border-radius:50%;background:var(--signal);display:flex;align-items:center;justify-content:center;text-align:center;font-family:'Archivo',sans-serif;font-weight:900;font-size:13px;text-transform:uppercase;line-height:1.15;padding:14px;flex-shrink:0}
  .sp .faq{margin-top:44px}
  .sp details{border-top:1px solid var(--line);padding:20px 0}
  .sp details:first-of-type{border-top:none}
  .sp summary{font-family:'Archivo',sans-serif;font-weight:700;font-size:17px;cursor:pointer;list-style:none;display:flex;justify-content:space-between;gap:16px}
  .sp summary::after{content:"+";font-family:'IBM Plex Mono',monospace;color:var(--cobalt);font-size:20px;flex-shrink:0}
  .sp details[open] summary::after{content:"\\2212"}
  .sp details p{margin-top:12px;color:var(--slate);font-size:15px;max-width:640px}
  .sp footer{border-top:1px solid var(--line);padding:44px 0;font-size:12px;color:var(--slate);text-align:center}
  .sp footer p{max-width:720px;margin:0 auto 10px}
  .sp-header{position:sticky;top:0;z-index:50;background:rgba(245,246,243,.9);backdrop-filter:blur(12px);border-bottom:1px solid var(--line)}
  .sp-header .inner{max-width:960px;margin:0 auto;padding:14px 24px;display:flex;align-items:center;justify-content:space-between}
  .sp-logo{font-family:'Archivo',sans-serif;font-weight:900;letter-spacing:-.02em;font-size:18px;text-transform:uppercase;color:#0F1317;text-decoration:none}
  .sp-login{font-family:'Archivo',sans-serif;font-weight:700;text-transform:uppercase;font-size:13px;letter-spacing:.04em;color:#0F1317;text-decoration:none;padding:8px 14px;border:1px solid #D9DDD6;border-radius:10px}
  @media(max-width:820px){
    .sp .steps{grid-template-columns:1fr 1fr}
    .sp .ledger{grid-template-columns:1fr}
    .sp .mult{flex-direction:row;gap:14px;padding:18px}
    .sp .mult .cap{margin-top:0;text-align:left}
    .sp .duo,.sp .qual,.sp .tgrid{grid-template-columns:1fr}
    .sp .bio{grid-template-columns:1fr}
    .sp .bio .photo{max-width:280px}
    .sp section{padding:64px 0}
  }
  @media(max-width:520px){
    .sp .steps{grid-template-columns:1fr}
    .sp .plan .row{grid-template-columns:52px 1fr;gap:14px}
    .sp .plan .num{font-size:30px}
    .sp .guarantee{grid-template-columns:1fr}
  }
`;

export default function SalesPage() {
  useEffect(() => { captureRefFromUrl(); }, []);

  return (
    <div className="sp">
      <style>{SALES_CSS}</style>

      {/* SLIM HEADER */}
      <header className="sp-header">
        <div className="inner">
          <a href="#top" className="sp-logo" data-testid="logo-wordmark">Weekend AI Offer</a>
          <Link to="/login" className="sp-login" data-testid="member-login-link">Member Login</Link>
        </div>
      </header>

      <div id="top" />
      <div className="proofbar">30-DAY ACTION-TAKER GUARANTEE</div>

      {/* 1. HERO */}
      <section className="hero">
        <div className="wrap">
          <span className="eyebrow">The Weekend AI Offer System</span>
          <h1>Launch a <span className="accent">$5K+ AI Offer</span><br />by Sunday Night</h1>
          <p className="sub">Package an outcome businesses already pay for, have the tech built for you once, and sell it on repeat. You bring the sales skill. The system brings everything else.</p>
          <div className="killers">
            <span className="pill">No coding</span>
            <span className="pill">No software to build</span>
            <span className="pill">No agency retainers</span>
            <span className="pill">No guru fluff</span>
          </div>
          <div className="cta">
            <div className="price"><s>$297</s> <b>$97</b> one-time</div>
            <BuyButton className="btn" hideIcon label="Get Instant Access" testId="hero-cta" />
            <div className="risk">Backed by the 30-Day Action-Taker Guarantee. Do the work, and if it doesn't deliver, get every dollar back.</div>
          </div>
        </div>
      </section>

      {/* 2. THE MODEL */}
      <section>
        <div className="wrap">
          <span className="eyebrow">The Model</span>
          <h2>Sell the Outcome.<br />Let AI Do the Fulfillment.</h2>
          <p className="lead" style={{ marginTop: 20, maxWidth: 640 }}>Most people trying to make money with AI are competing on technology. That's backwards. The money is in packaging a result a funded market is already desperate to buy, then using AI to deliver it at near-zero cost.</p>
          <div className="steps">
            <div className="step"><span className="n">STEP 01</span><h3>Pick a funded pain</h3><p>Choose a market already spending real money to solve a specific, painful problem.</p></div>
            <div className="step"><span className="n">STEP 02</span><h3>Package the outcome</h3><p>Name the result, price it high, and position it as a business transformation, not a tool.</p></div>
            <div className="step"><span className="n">STEP 03</span><h3>Build it once, cheap</h3><p>Hand a freelancer the exact specs. They build the AI delivery system. You own it forever.</p></div>
            <div className="step"><span className="n">STEP 04</span><h3>Sell it on repeat</h3><p>Every new client runs through the same system. Margin goes up. Your hours don't.</p></div>
          </div>
        </div>
      </section>

      {/* 3. SIGNATURE: POSITIONING LEDGER */}
      <section className="ledger-sec">
        <div className="wrap">
          <span className="eyebrow">Positioning Is the Product</span>
          <h2>Same Tech.<br />Wildly Different Price.</h2>
          <div className="ledger">
            <div className="side them">
              <span className="tag">What everyone else sells</span>
              <div className="offer-name">"An AI Chatbot for Your Website"</div>
              <div className="offer-price">$300<span style={{ fontSize: 16 }}>/mo</span></div>
              <p className="desc">A commodity. Compared on price against a thousand identical sellers. Churns in 90 days.</p>
            </div>
            <div className="mult">
              <div className="x">17×</div>
              <div className="cap">The positioning<br />multiplier</div>
            </div>
            <div className="side you">
              <span className="tag">What you'll sell</span>
              <div className="offer-name">"A 24/7 Lead Conversion System That Books Sales Calls While You Sleep"</div>
              <div className="offer-price">$5,000<span style={{ fontSize: 16 }}>+ setup</span></div>
              <p className="desc">An outcome. Compared against the cost of a full-time employee. Renews because it prints revenue.</p>
            </div>
          </div>
          <p className="ledger-note">Illustrative example. The underlying technology is identical. The packaging is not.</p>
        </div>
      </section>

      {/* 4. THE TRAP */}
      <section>
        <div className="wrap">
          <span className="eyebrow">The Fork in the Road</span>
          <h2>The AI Agency Trap<br /><span className="accent">vs. The Owner's Path</span></h2>
          <div className="duo">
            <div className="col bad">
              <h3>The trap most people fall into</h3>
              <ul>
                <li>Selling the same chatbots as everyone else and competing on price</li>
                <li>Spending nights learning dev tutorials instead of closing deals</li>
                <li>Custom-building every client project from scratch, forever</li>
              </ul>
            </div>
            <div className="col good">
              <h3>What you'll do instead</h3>
              <ul>
                <li>Find profitable problems nobody else is packaging</li>
                <li>Pay a freelancer once to build your delivery system</li>
                <li>Sell the same proven offer over and over at premium prices</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 5. PROOF OF CONCEPT */}
      <section>
        <div className="narrow">
          <span className="eyebrow">Included: A Working Example</span>
          <h2>You Don't Start From a Blank Page</h2>
          <p className="lead" style={{ marginTop: 20 }}>Inside the program you get a complete, working demo offer: the positioning, the pricing, the fulfillment specs, and the sales assets, fully built out. Reverse-engineer it, model it, or launch your own version of it this weekend. It exists to prove one thing: this model works before you've risked a dollar on your own idea.</p>
        </div>
      </section>

      {/* 6. THE WEEKEND PLAN */}
      <section>
        <div className="narrow">
          <span className="eyebrow">The Launch Plan</span>
          <h2>Friday Night to Sunday Night</h2>
          <div className="plan">
            <div className="row"><div className="num">1</div><div><span className="when">Friday evening</span><h3>Pick your market</h3><p>Use the pre-researched market list to choose a niche that's already spending thousands on this problem.</p></div></div>
            <div className="row"><div className="num">2</div><div><span className="when">Saturday morning</span><h3>Confirm the pain</h3><p>Run the research prompts to surface the exact language your market uses to describe what's costing them money.</p></div></div>
            <div className="row"><div className="num">3</div><div><span className="when">Saturday afternoon</span><h3>Package your offer</h3><p>Use the positioning frameworks to turn a cheap tool into a premium, outcome-priced package.</p></div></div>
            <div className="row"><div className="num">4</div><div><span className="when">Sunday morning</span><h3>Spec the build</h3><p>Post the done-for-you job listing, filter freelancers with the provided interview questions, and hand off the specs.</p></div></div>
            <div className="row"><div className="num">5</div><div><span className="when">Sunday night</span><h3>Open your pipeline</h3><p>Deploy the outreach and enrollment scripts and start conversations with your first prospects.</p></div></div>
          </div>
        </div>
      </section>

      {/* 7. BIO */}
      <section>
        <div className="wrap">
          <span className="eyebrow">Who's Teaching This</span>
          <h2>I Sell for a Living.<br /><span className="accent">I Never Learned to Code.</span></h2>
          <div className="bio">
            <div className="photo"><img src="/hom-weusi.jpg" alt="Hom Weusi, creator of The Weekend AI Offer System." loading="lazy" /></div>
            <div>
              <p className="lead">I'm Hom Weusi. I spent 13 years owning brick-and-mortar businesses, a fitness facility and a wellness cafe, built from nothing and run the hard way. I learned what every owner learns eventually: if the business only makes money while you're standing in it, you don't own a business. It owns you.</p>
              <p style={{ color: "var(--slate)", marginTop: 16 }}>So I went and mastered the other side of the equation: high-ticket sales. As the solo full-cycle closer for an online coaching program, I ran every enrollment call myself, built my own framework from the transcripts, and closed premium clients month after month without a team behind me.</p>
              <p style={{ color: "var(--slate)", marginTop: 16 }}>Here's the part that matters for you: I am not a developer. When I wanted an AI product of my own, I didn't spend six months in tutorials. I wrote the spec, had it built, and I own it. That's not a story I read somewhere. It's the exact model inside this program, because I used it first.</p>
              <ul className="cred">
                <li>13 years owning and operating my own businesses before ever teaching anyone</li>
                <li>Solo full-cycle closer averaging 10 high-ticket enrollments a month at a 23% close rate</li>
                <li>Creator of the CARE enrollment framework (Connect, Awareness, Resolve, Enroll)</li>
                <li>Built and launched AI-fulfilled products without writing a single line of code</li>
                <li>Licensed Texas real estate agent with high-ticket transactions on both sides of the table</li>
              </ul>
              <p className="belief">Businesses don't buy AI. They buy outcomes. My rule comes from Wallace Wattles: give more in use value than you take in cash value. Price the outcome, over-deliver the result, and selling stops feeling like selling.</p>
            </div>
          </div>
        </div>
      </section>

      {/* 8. TESTIMONIALS — removed for launch; reintroduce with real, permissioned student results */}

      {/* 9. QUALIFICATION */}
      <section>
        <div className="wrap">
          <span className="eyebrow">Read This Before You Buy</span>
          <h2>This Is For a Specific Kind of Person</h2>
          <div className="qual">
            <div className="col yes">
              <h3>This is for you if</h3>
              <ul>
                <li>You want to launch a high-ticket AI offer without writing a line of code</li>
                <li>You value speed and leverage over endless courses and tutorials</li>
                <li>You're an action-taker who will actually run the weekend plan</li>
                <li>You'd rather sell outcomes than compete on technical complexity</li>
              </ul>
            </div>
            <div className="col no">
              <h3>This is not for you if</h3>
              <ul>
                <li>You're looking for passive income with zero effort</li>
                <li>You want to become a developer or build software yourself</li>
                <li>You collect courses instead of finishing them</li>
                <li>You need guaranteed income promises (nobody honest can offer that)</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 10. VALUE STACK */}
      <section>
        <div className="wrap">
          <span className="eyebrow">Everything You Get</span>
          <h2>The Complete Weekend Launch Kit</h2>
          <div className="stack">
            <div className="item"><div><h3>The Core Training</h3><p>The full sell-the-outcome model, from market selection to first client, in tight, watch-once modules.</p></div><div className="val">$297 value</div></div>
            <div className="item"><div><h3>Pre-Researched Market List</h3><p>Funded niches already spending thousands on painful problems. Pick one and follow the plan.</p></div><div className="val">$197 value</div></div>
            <div className="item"><div><h3>Pain-Point Research Prompts</h3><p>Drop-in prompts that surface high-ticket pain points your competitors aren't seeing.</p></div><div className="val">$97 value</div></div>
            <div className="item"><div><h3>Premium Positioning Frameworks</h3><p>Turn inexpensive tools into outcome-priced packages that sell for 10x more.</p></div><div className="val">$197 value</div></div>
            <div className="item"><div><h3>Freelancer Hiring System</h3><p>Job post templates, filtering criteria, and interview questions to get your system built affordably.</p></div><div className="val">$147 value</div></div>
            <div className="item"><div><h3>The Working Demo Offer</h3><p>A complete example offer with positioning, pricing, and fulfillment specs to model or launch.</p></div><div className="val">$497 value</div></div>
            <div className="item"><div><h3>Offer Breakdown Library</h3><p>Teardowns of profitable offers: what they're called, who buys them, and exactly what to charge.</p></div><div className="val">$197 value</div></div>
            <div className="item"><div><h3>Enrollment &amp; Outreach Scripts</h3><p>Word-for-word conversation frameworks to open pipeline and close without sounding like everyone else.</p></div><div className="val">$247 value</div></div>
            <div className="item bonus"><div><h3><span className="bonus-tag">BONUS</span>1-on-1 Launch Call</h3><p>A private implementation call to pressure-test your offer before you launch. Limited spots each month, first come first served.</p></div><div className="val">$300 value</div></div>
          </div>
          <div className="stack" style={{ marginTop: 0, borderTop: "none", borderRadius: "0 0 16px 16px", overflow: "hidden" }}>
            <div className="total"><span className="label">Total value vs. today's price</span><span className="figs"><s>$2,176</s> <b>$97</b></span></div>
          </div>
          <div className="cta" id="checkout">
            <div className="price"><s>$297</s> <b>$97</b> one-time</div>
            <BuyButton className="btn" hideIcon label="Get Instant Access" testId="pricing-cta" />
            <div className="risk">30-Day Action-Taker Guarantee. Instant access. Nothing else to buy.</div>
          </div>
        </div>
      </section>

      {/* 11. REFERRAL */}
      <section>
        <div className="wrap">
          <div className="refer">
            <h2>One Referral Pays for the Whole Thing</h2>
            <p>Every member gets a referral link at checkout. Send one person who joins, and your $97 comes back to you.</p>
          </div>
        </div>
      </section>

      {/* 12. GUARANTEE + FAQ + FINAL CTA */}
      <section>
        <div className="narrow">
          <span className="eyebrow">The Guarantee</span>
          <h2>Do the Work. Or Get Your Money Back.</h2>
          <div className="guarantee">
            <div className="seal">30-Day Action Taker Guarantee</div>
            <p style={{ color: "var(--slate)" }}>Go through the training, run the weekend plan, and show us your work: your chosen market, your packaged offer, and your freelancer job post. If you've done that within 30 days and you don't believe this was worth every penny, email us and we'll refund you in full. This guarantee protects action-takers, not tire-kickers, and that's deliberate.</p>
          </div>

          <div className="faq">
            <span className="eyebrow" style={{ marginTop: 56 }}>Common Questions</span>
            <details><summary>Do I need any technical or coding skills?</summary><p>No. The entire model is built so that a freelancer handles the technical build from specs we hand you. Your job is selection, packaging, and selling.</p></details>
            <details><summary>How much money do I need beyond the $97?</summary><p>Plan for a modest freelancer budget to build your delivery system once. The hiring kit is designed to keep that build affordable, and you own the result permanently.</p></details>
            <details><summary>Can I really do this in a weekend?</summary><p>The launch plan is scoped to a Friday-to-Sunday sprint for choosing a market, packaging an offer, and posting your build spec. Landing your first client takes as long as your outreach takes. The weekend gets you to "open for business."</p></details>
            <details><summary>What if my market is already saturated?</summary><p>Saturation lives at the tool level, not the outcome level. Thousands of people sell chatbots. Very few package specific business outcomes for specific funded niches. That's the whole point of the positioning frameworks.</p></details>
            <details><summary>Is this an agency model?</summary><p>No. Agencies trade hours for retainers and rebuild everything per client. This model has you build one delivery system once and sell it repeatedly. Different economics entirely.</p></details>
            <details><summary>How is this different from other AI courses?</summary><p>Most AI courses teach you technology. This teaches you packaging, positioning, and selling, which is where the margin actually lives. You'll spend zero time in dev tutorials.</p></details>
            <details><summary>How long do I have access?</summary><p>Lifetime access, including future updates to the training and the offer breakdown library.</p></details>
            <details><summary>What if I'm brand new to sales?</summary><p>The enrollment scripts are word-for-word frameworks. You don't need sales experience to start; you need willingness to have conversations. The 1-on-1 launch call bonus exists to sharpen exactly this.</p></details>
            <details><summary>How does the guarantee work, exactly?</summary><p>Complete the training and submit your weekend-plan work within 30 days of purchase. If it wasn't worth it to you, email support with your work attached and you'll receive a full refund.</p></details>
          </div>

          <div className="cta">
            <div className="price"><s>$297</s> <b>$97</b> one-time</div>
            <BuyButton className="btn" hideIcon label="Launch My AI Offer This Weekend" testId="final-cta" />
            <div className="risk">Instant access · 30-Day Action-Taker Guarantee · One referral covers your cost</div>
          </div>
        </div>
      </section>

      <footer>
        <div className="wrap">
          <p>Earnings Disclaimer: We make no guarantees regarding income or results. All business involves risk, and outcomes depend on your individual effort, skill, and market conditions. Any results referenced are not typical and are not a promise of your results.</p>
          <p>© 2026 Weekend AI Offer. All rights reserved. · <Link to="/login" style={{ color: "var(--slate)" }}>Member Login</Link></p>
        </div>
      </footer>
    </div>
  );
}
